import { render } from "./prescription-transfer.vue?vue&type=template&id=2b8c3b25&ts=true"
import script from "./prescription-transfer.vue?vue&type=script&lang=ts"
export * from "./prescription-transfer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__